module.exports = __webpack_public_path__ + "static/media/animal-horse4.2aecb455.aac";